var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pictures-content"},[_c('div',{staticClass:"container"},[_c('v-panel-content',{attrs:{"data-salce":_vm.triggerSideNavShow}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }